import { render, staticRenderFns } from "./AllergensLegend.vue?vue&type=template&id=0b5d3721&scoped=true&"
import script from "./AllergensLegend.vue?vue&type=script&lang=js&"
export * from "./AllergensLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d3721",
  null
  
)

export default component.exports